import { render, staticRenderFns } from "./StandQuestion.vue?vue&type=template&id=d25f6076&scoped=true&"
import script from "./StandQuestion.vue?vue&type=script&lang=js&"
export * from "./StandQuestion.vue?vue&type=script&lang=js&"
import style0 from "./StandQuestion.vue?vue&type=style&index=0&id=d25f6076&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25f6076",
  null
  
)

export default component.exports